import { RouteObject } from 'react-router-dom'
import HomePage from './home'
import DashboardLayout from 'layout/dashboard/dashboardLayout'
import FundsPage from './funds'
import MessagesPage from './messages'
import TransactionsPage from './transactions'
import ErrorBug from 'components/errors/bugs'

export const dashboardRoutes: RouteObject[] = [
    {
        path: '/',
        element: <DashboardLayout />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: true,
                path: 'home',
                element: <HomePage />,
            },
            {
                index: false,
                path: 'funds',
                element: <FundsPage />,
            },
            {
                index: false,
                path: 'messages',
                element: <MessagesPage />,
            },
            {
                index: false,
                path: 'transactions',
                element: <TransactionsPage />,
            },
        ],
    },
]
